/**
 * BNPL provider consent gate, client half (ERS-75)
 *
 * The checkbox renders in every environment so the wording can be reviewed with real patients
 * during the soft launch. What production does NOT have is the provider's privacy document: the
 * only link Credi2 has issued so far points at their TEST site, so `appInfo/bnplLegalDocuments` is
 * seeded there without a `link` and the phrase renders as plain text (see `ConsentLink` on the
 * payment screen). The link appears on its own once the real URL lands in that document.
 *
 * This is deliberately independent of the server gate `fn/bnpl/shared/softLaunchGate.ts`, which
 * still suppresses every provider call in production. Collecting the consent does not start the
 * provider flow.
 */

/**
 * Whether the provider DATA_PRIVACY consent is collected on this build.
 *
 * @return {boolean} True when the checkbox must render and the consent text is required.
 */
export function isBnplProviderConsentCollectionEnabled(): boolean {
  return true;
}

/**
 * Marker id `runCoursePaymentCheckout` returns instead of a real payment id during the soft launch.
 * Client copy of `SOFT_LAUNCH_PAYMENT_ID` in `physiofit_cloud_functions/functions/fn/bnpl/shared/softLaunchGate.ts`;
 * the string is the contract, keep both in sync.
 */
export const SOFT_LAUNCH_PAYMENT_ID = 'bnpl-soft-launch-skipped';

/**
 * Whether a checkout result came from the soft-launch escape rather than the provider.
 *
 * Read off the response, not off the build mode: it is the server that decided to skip the provider,
 * and stamping analytics from its answer keeps a mocked acceptance distinguishable from a real one
 * after the launch (ERS-79 item 8). That cannot be reconstructed later.
 *
 * @param {string} rbiCoursePaymentId Payment id from `RunCoursePaymentCheckoutResponse`.
 *
 * @return {boolean} True when the provider was skipped.
 */
export function isSoftLaunchPayment(rbiCoursePaymentId: string): boolean {
  return rbiCoursePaymentId === SOFT_LAUNCH_PAYMENT_ID;
}
